import { useEffect } from 'react';

const DRAG_THRESHOLD = 5;

export const useSliderMomentum = (ref, active = true) => {
  useEffect(() => {
    const slider = active && ref.current;
    if (!slider) return undefined;

    let isDown = false;
    let dragged = false;
    let startX = 0;
    let scrollLeft = 0;
    slider.style.cursor = 'grab';

    const onMouseDown = e => {
      if (e.button !== 0) return;
      e.preventDefault();
      isDown = true;
      dragged = false;
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
    };
    const onMouseMove = e => {
      isDown = isDown && e.buttons !== 0;
      if (!isDown) return;
      const walk = e.pageX - startX;
      if (!dragged && Math.abs(walk) < DRAG_THRESHOLD) return;
      dragged = true;
      slider.style.cursor = 'grabbing';
      slider.scrollLeft = scrollLeft - walk;
    };
    const onMouseUp = () => {
      isDown = false;
      slider.style.cursor = 'grab';
      setTimeout(() => {
        dragged = false;
      }, 0);
    };
    const onClick = e => {
      if (!dragged) return;
      dragged = false;
      e.preventDefault();
      e.stopPropagation();
    };

    const controller = new AbortController();
    slider.addEventListener('mousedown', onMouseDown, { signal: controller.signal });
    slider.addEventListener('mousemove', onMouseMove, { signal: controller.signal });
    window.addEventListener('mouseup', onMouseUp, { signal: controller.signal });
    slider.addEventListener('click', onClick, { capture: true, signal: controller.signal });
    return () => controller.abort();
  }, [ref, active]);
};

export default useSliderMomentum;
